export default "__VITE_ASSET__DeOdrkNX__"